// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/player." + chunkId + "." + {"86":"61cc5b","127":"ea4ab5","141":"ce260e","167":"0af069","184":"792621","267":"588282","274":"bb598d","334":"e51e85","389":"fcd99c","434":"ea6e11","550":"2c434c","600":"a9c181","615":"d012d2","640":"aa4c87","672":"a85ede","719":"9ddcb0","820":"b0cd1d","949":"9b83ac"}[chunkId] + ".js";
};